import { cn } from '~/common/utils/styleUtil';
import type { ReactNode } from 'react';
import { DropdownMenuItem } from '~/common/components/ui/dropdown-menu';
import * as React from 'react';
import type * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export interface NavDropDownMenuItemProps {
  children: ReactNode;
  className?: string;
}

export function NavDropDownMenuItem({
  children,
  className,
  ...props
}:
  | NavDropDownMenuItemProps
  | (React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Item> & {
      inset?: boolean;
    })) {
  return (
    <DropdownMenuItem
      className={cn(
        'min-w-[200px] cursor-pointer border-b py-3 hover:text-primary hover:bg-white focus:bg-white focus:text-primary',
        className
      )}
      {...props}
    >
      {children}
    </DropdownMenuItem>
  );
}
